import React, { FC, useState, useEffect, memo } from "../../../../lib/teact/teact";
import CongNoChiTiet from "./congNoChiTiet";
import CongNoTongHop from "./congNoTongHop";

type OwnProps = {

}
enum CurForm {
    CongNoTongHop,
    CongNoChiTiet,
}

const CongNoMain: FC<OwnProps> = ({

}) => {
    const [state, setState] = useState({
        Render: {
            cur: CurForm.CongNoTongHop,
        },
        curContactId: 0,
    })
    useEffect(() => {

    }, [])
    /*màn hình công nợ tổng hợp, click vào 1 contact*/
    function handleContactIdClick(contactId: number) {
        setState(prev => ({
            ...prev, curContactId: contactId,
            Render: { ...prev.Render, cur: CurForm.CongNoChiTiet }
        }))
    }
    function handleBackToCongNoTongHop() {
        setState(prev => ({ ...prev, Render: { ...prev.Render, cur: CurForm.CongNoTongHop } }))
    }
    return (
        <>
            {
                state.Render.cur == CurForm.CongNoTongHop &&
                <CongNoTongHop onContactIdClicked={handleContactIdClick} />
            }
            {
                state.Render.cur == CurForm.CongNoChiTiet &&
                <CongNoChiTiet contactId={state.curContactId} onBackToCongNoTongHop={handleBackToCongNoTongHop} />
            }
        </>
    )
}

export default memo(CongNoMain)